import { useApi } from "./api-service";
import { IReportCallData } from "../../types/call";
import { toBackendReportCallData } from "../converters/calls-converter";

export function useCallsService() {
  const agentRequired = false;
  const callsApi = useApi(agentRequired);

  return {
    reportIssue: async (
      callId: string,
      data: IReportCallData
    ): Promise<void> => {
      return callsApi.post<void>(
        `/calls/${callId}/issue`,
        toBackendReportCallData(data)
      );
    },
  };
}
